export const playerConfig = {
  hairColor: 'Red',
  eyeColor: 'Blue',
  hat: 'No Hat',
  shield: 'Common Shield',
  weapon: 'Epic Sword',
  chest: 'No Chest Plate',
  shoulder: 'No Shoulder'
};
